import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPenIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="#000"
      d="M4.168 15h3.533a.83.83 0 0 0 .592-.242l5.767-5.775 2.366-2.316a.833.833 0 0 0 0-1.184l-3.533-3.575a.834.834 0 0 0-1.183 0L9.36 4.267l-5.784 5.775a.83.83 0 0 0-.241.591v3.534a.833.833 0 0 0 .833.833m8.133-11.325 2.359 2.358-1.184 1.184-2.358-2.359zm-7.3 7.3 4.942-4.942 2.358 2.359-4.941 4.941H5zm12.5 5.692h-15a.833.833 0 1 0 0 1.666h15a.833.833 0 0 0 0-1.666"
    />
  </svg>
);
export default SvgPenIcon;
